export const asString = (value: number | string) =>
  typeof value == "string" ? value : value.toString();
